"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

//import "./AppBar.scss";
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    zIndex: 10,
    height: "64px",
    top: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    marginTop: "-64px",
    marginLeft: theme.spacing(.5),
    marginRight: theme.spacing(.5),
    "& > * ": {
      marginLeft: theme.spacing(.5),
      marginRight: theme.spacing(.5)
    },
    "&[aria-expanded=true]": {
      marginTop: 0
    }
  }
}));

const AdminNav = ({
  expanded,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement("nav", {
    className: classes.root,
    "aria-expanded": expanded
  }, children);
};

var _default = AdminNav;
exports.default = _default;
module.exports = exports.default;